// Domain types + thin zod validation layer, derived from
// contracts/storefront-api.openapi.yaml (US-003/US-004). Pure types/zod only —
// no server-only, no fetch.
export * from "./types"
export * from "./layout"
export * from "./theme"
export * from "./store-config"
export * from "./hero"
export * from "./showcase"
export * from "./legal"
export * from "./gallery"
export * from "./menu-files"
export * from "./announcements"
export * from "./promotions"
export * from "./hygiene-rating"
export * from "./order-status"
export * from "./analytics-config"
export * from "./item-option-selection"

export const MODEL_PACKAGE = "@workspace/model" as const
